import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import { fr } from 'react-day-picker/locale';
import { ChevronUp, ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';

import { cn } from '@shared/utils/cn';

import { buttonVariants } from './button';

// Calendrier (react-day-picker). Cellules 40px (cible tactile).
const Calendar = ({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: React.ComponentProps<typeof DayPicker>) => (
  <DayPicker
    className={cn('p-3', className)}
    classNames={{
      root: 'w-fit',
      months: 'relative flex flex-col gap-4 sm:flex-row',
      month: 'flex w-full flex-col gap-4',
      nav: 'absolute inset-x-0 top-0 flex w-full items-center justify-between',
      button_previous: cn(buttonVariants({ variant: 'ghost', size: 'icon' }), 'size-10 p-0 aria-disabled:opacity-50'),
      button_next: cn(buttonVariants({ variant: 'ghost', size: 'icon' }), 'size-10 p-0 aria-disabled:opacity-50'),
      month_caption: 'flex h-10 w-full items-center justify-center px-10',
      caption_label:
        'flex items-center gap-1 pr-1 pl-3 text-sm font-semibold select-none [&>svg]:size-4 [&>svg]:text-muted-foreground',
      dropdowns: 'flex items-center justify-center gap-1.5',
      dropdown_root:
        'relative inline-flex h-9 items-center rounded-md border border-input has-focus:ring-[3px] has-focus:ring-ring/50',
      dropdown: 'absolute inset-0 cursor-pointer opacity-0',
      months_dropdown: 'text-sm',
      years_dropdown: 'text-sm',
      month_grid: 'w-full border-collapse',
      weekdays: 'flex',
      weekday: 'w-10 text-center text-xs font-semibold text-muted-foreground select-none',
      week: 'mt-1 flex w-full',
      day: 'relative size-10 p-0 text-center text-sm select-none',
      day_button: cn(buttonVariants({ variant: 'ghost', size: 'icon' }), 'size-10 p-0 font-normal'),
      selected:
        '[&>button]:bg-primary [&>button]:text-primary-foreground [&>button]:hover:bg-primary/90 [&>button]:font-semibold',
      today: '[&>button]:border [&>button]:border-primary',
      outside: 'text-muted-foreground opacity-50',
      disabled: 'text-muted-foreground opacity-40',
      hidden: 'invisible',
      ...classNames,
    }}
    components={{
      Chevron: ({ orientation, className: chevronClassName }) => {
        const classes = cn('size-5', chevronClassName);
        if (orientation === 'left') return <ChevronLeft className={classes} />;
        if (orientation === 'right') return <ChevronRight className={classes} />;
        if (orientation === 'up') return <ChevronUp className={classes} />;
        return <ChevronDown className={classes} />;
      },
    }}
    data-slot="calendar"
    locale={fr}
    showOutsideDays={showOutsideDays}
    {...props}
  />
);

export { Calendar };
